import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabIVC as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabIVC = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const submittedApplicationField = () => {
    const propertyName = pn<AprResponseModel>("submittedApplication");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.submittedApplication}{" "}
        {formatPercentTotal(props.data?.submittedApplication, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const otherApplicationStatusField = () => {
    const propertyName = pn<AprResponseModel>("otherApplicationStatus");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.otherApplicationStatus}{" "}
        {formatPercentTotal(props.data?.otherApplicationStatus, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknownApplicationStatusField = () => {
    const propertyName = pn<AprResponseModel>("unknownApplicationStatus");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknownApplicationStatus} {formatPercentTotal(props.data?.unknownApplicationStatus, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Financial Aid Applications</Typography>
        <Grid container spacing="lg">
          <Grid item xs={11}>
            <Grid container spacing="lg">
              {props.data?.submittedApplication != null && (
                <Grid item xs={12}>
                  {submittedApplicationField()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.otherApplicationStatus != null && (
                <Grid item xs={12}>
                  {otherApplicationStatusField()}
                </Grid>
              )}

              {props.data?.unknownApplicationStatus != null && (
                <Grid item xs={12}>
                  {unknownApplicationStatusField()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          {/* <Grid item xs={6}>
            <PieChart
              id="pie-tab-a"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid> */}
        </Grid>
      </Stack>
    </Card>
  );
};
